import QRCode from 'react-qr-code'
import { Modal } from 'react-bootstrap'
import { getConfig } from 'utils'

export default function QRCodeModal({
    qrPlugin = false,
    show,
    handleClose,
    title,
    qrValue,
    codeText,
}) {
    const displayCode = codeText ?? (qrPlugin ? qrValue : null)

    return (
        <Modal show={show} onHide={handleClose} size="sm" centered>
            <Modal.Header closeButton>
                <Modal.Title>{title || 'QR Code'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex flex-column justify-content-center align-items-center gap-3 py-4">
                {qrValue ? (
                    <>
                        {qrPlugin ? (
                            <QRCode value={qrValue} size={256} />
                        ) : (
                            <img src={getConfig.BASE_URL + qrValue} alt="QR Code" className="img-fluid" />
                        )}
                        {displayCode ? (
                            <p
                                className="mb-0 text-center fw-semibold"
                                style={{ fontSize: '14px', color: '#0f172a', wordBreak: 'break-word' }}
                            >
                                {displayCode}
                            </p>
                        ) : null}
                    </>
                ) : (
                    <p className="text-muted mb-0">No QR data available</p>
                )}
            </Modal.Body>
        </Modal>
    )
}